/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export function WelcomeWidget({ className, user }) {
  const { name, access_role, organization } = user;

  const backgroundImageUrl = toAbsoluteUrl("/media/stock-600x600/img-16.jpg");

  return (
    <>
      <div
        className={`card card-custom bgi-no-repeat bgi-size-cover ${className}`}
        style={{
          backgroundImage: `url("${backgroundImageUrl}")`
        }}
      >
        {/* begin::Body */}
        <div className="card-body d-flex flex-column align-items-start justify-content-start">
          <div className="p-1 flex-grow-1">
            <h3 className="text-white font-weight-bolder line-height-lg mb-5">
              Selamat Datang {name}
              <br />
              {access_role.name.toLowerCase() == "superadmin"
                ? "Admin"
                : access_role.name}{" "}
              {organization.name}
            </h3>
          </div>
        </div>
        {/* end::Body */}
      </div>
    </>
  );
}
